<div class="grid">
  <div class="col-12">
    <p-panel header="{{ 'SUCURSALES.LBL_CUPOS' | translate}}" class="overflow-y-unset">
      <div class="grid">
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label>* {{'ALIADOSUCURSALCUPO.LBL_RANGOFECHAS' | translate}}</label>
            <p-calendar [(ngModel)]="fechas" [locale]="es" dateFormat="yy/mm/dd"
                        placeholder="fecha inicio-fecha fin" selectionMode="range" showButtonBar="true"
                        [monthNavigator]="true" [yearNavigator]="true" (onSelect)="filtroFechas()"
                        (onClearClick)="limpiarFiltroFechas()"
                        yearRange="{{calendarProperties.rango}}"
                        [readonlyInput]="true" [showIcon]="true"></p-calendar>
          </div>
        </div>
      </div>
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <p-table [columns]="columnas" [loading]="carTabla" #dt
                   [value]="listadoAliadosSucursalesCupos" selectionMode="single" dataKey="idAliadoSucursal"
                   [paginator]="true" [rows]="10"  paginatorPosition="bottom">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                    class="text-center">
                  {{col.header}}
                  <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr [pSelectableRow]="row">
                <td>{{row.fechaInicio |date:'yyyy-MM-dd'}}</td>
                <td>{{row.fechaFin|date:'yyyy-MM-dd'}}</td>
                <td style="text-align: right">{{row.cupoValor|dinero: 2}}</td>
                <td>{{row.cupoCredito}}</td>
                <td style="text-align: right">{{row.totalValorConsumido |dinero: 2}}</td>
                <td>{{row.totalCreditoConsumido}}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="columns.length" class="text-center">
                  {{ 'MSG_NOHAYREGISTROS' | translate}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </p-panel>
  </div>
</div>
